<div id="auth-create-password" class="auth-container">
  <h2>Create Your Password</h2>

  <form
    class="form-1 mat-elevation-z5 p-4"
    [formGroup]="createPasswordForm"
    (ngSubmit)="onSubmit()"
    >
    <h4>Set a password to finish creating your account and keep access to your order history.</h4>
    <div class="form-field">
      @if (showLabels) {
        <label for="auth-create-password-password" class="form-label">
          Password <span class="required-asterisk">*</span>
        </label>
      }
      <input
        type="password"
        formControlName="password"
        #passwordInput
        id="auth-create-password-password"
        [placeholder]="!showLabels ? 'Password' : ''"
        [class.error]="hasError(password)"
        />
      <div class="form-error" [class.show]="hasError(password)">
        <div class="form-error" [class.show]="hasErrorRequired(password)">Password is required.</div>
      </div>
    </div>
    <div class="form-field">
      @if (showLabels) {
        <label for="auth-create-password-retypePassword" class="form-label">
          Retype Password <span class="required-asterisk">*</span>
        </label>
      }
      <input
        type="password"
        formControlName="retypePassword"
        #retypePasswordInput
        id="auth-create-password-retypePassword"
        [placeholder]="!showLabels ? 'Retype Password' : ''"
        [class.error]="hasError(retypePassword)"
        />
      <div class="form-error" [class.show]="hasError(retypePassword)">
        <div class="form-error" [class.show]="hasErrorRequired(retypePassword)">Please retype your password.</div>
        <div class="form-error" [class.show]="hasErrorMatch(retypePassword)">Passwords do not match.</div>
      </div>
    </div>
    <span class="form-messages">{{ messageService.locals.createPassword }}</span>
    <button class="button-primary button-base" type="submit" [disabled]="buttonClicked">
      @if (actionPending) {
        <mat-spinner diameter="18" class="spc-blue-gray-300"></mat-spinner>
      }
      @if (!actionPending) {
        <span>Save</span>
      }
    </button>
    <div class="grecaptcha-message mt-3">
      This site is protected by reCAPTCHA and the Google
      <a href="https://policies.google.com/privacy">Privacy Policy</a> and
      <a href="https://policies.google.com/terms">Terms of Service</a> apply.
    </div>
  </form>
</div>
